import { useContext } from 'react';
import { AbilityContext } from '../users/UseUserPermissions';

/**
 * useCanEditNoteCategories - CASL gate for managing tenant note categories.
 *
 * Categories admin is bundled into the same `manage:notes` (Full Access)
 * permission as note creation and review-status change.
 */
export const useCanEditNoteCategories = (): boolean => {
  const ctx = useContext(AbilityContext);

  return ctx?.permissions?.can('manage', 'notes') ?? false;
};
